import HTTPClient from './http-client';

const END_POINT_RESERVOIR_SUMMARY = '/reservoir_latestdailysummary';
const END_POINT_SAIC_DAILY_SUMMARY = '/saic_dailysummary';
const END_POINT_SAIC_MONTHLY_SUMMARY = '/saic_monthlysummary';


const loadReservoirLatestDailySummary = async () =>{
  const httpClient = new HTTPClient();
  const api = await httpClient.configure();
  return api.get(`${END_POINT_RESERVOIR_SUMMARY}`);
}


const loadSaicDailySummaryAPI = async (startDate, endDate) =>{
    const httpClient = new HTTPClient();
    const api = await httpClient.configure();
    return api.get(`${END_POINT_SAIC_DAILY_SUMMARY}?startDate=${startDate}&endDate=${endDate}`);
}
const loadSaicMonthlySummaryAPI = async (startDate, endDate) =>{
    const httpClient = new HTTPClient();
    const api = await httpClient.configure();
    return api.get(`${END_POINT_SAIC_MONTHLY_SUMMARY}?startYM=${startDate}&endYM=${endDate}`);
}

export {
    loadReservoirLatestDailySummary,
    loadSaicDailySummaryAPI,
    loadSaicMonthlySummaryAPI,
}
